export const createHashTable = <T>(items: T[], orderBy: keyof T) => items.reduce<Record<number, T[keyof T]>>((acc, curr, index) => ({ ...acc, [index]: curr[orderBy] }), {})
